export class BaseDirective {

  teclasPermitidas = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight'
  ];

  constructor() {}

  teclaPermitidaPresionada(event: KeyboardEvent): boolean {
    return this.teclasPermitidas.includes(event.key);
  }
}
